import type { Session } from "@supabase/supabase-js";

// Token rotation is not navigation or a new data owner. Keep credentials
// current without changing every panel's stable display-session prop.
let current: Session | null = null;
let initialized = false;
let lifetime = new AbortController();
export function setCurrentApiSession(session: Session | null): void {
  if (initialized && current?.user.id !== session?.user.id) {
    lifetime.abort(new DOMException("Session changed", "AbortError"));
    lifetime = new AbortController();
  }
  current = session;
  initialized = true;
}
export function currentApiSession(fallback: Session): Session {
  if (!initialized) return fallback; // isolated components/tests
  if (!current || current.user.id !== fallback.user.id) {
    throw new Error("session_changed");
  }
  return current;
}
export function apiSessionSignal(fallback: Session): AbortSignal {
  currentApiSession(fallback);
  return lifetime.signal;
}
export function sameSessionIdentity(a: Session | null, b: Session | null): boolean {
  if (!a || !b) return a === b;
  // Include all user metadata: role, verification and account changes must
  // remain observable. Exclude access/refresh token and expiry rotation only.
  return JSON.stringify(a.user) === JSON.stringify(b.user);
}
